// A short two-tone "ping" synthesized with the Web Audio API — no binary asset to ship/host.
// The AudioContext is created lazily (and reused) since browsers only allow it to start once
// the page has seen a user gesture; if it's still suspended when a socket push arrives, resume()
// is best-effort and failures are swallowed rather than surfaced (a missed sound isn't worth
// breaking the notification flow over).
let audioCtx = null;

function getAudioContext() {
  if (!audioCtx) {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
  }
  return audioCtx;
}

function playTone(ctx, frequency, startTime, duration) {
  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();
  oscillator.type = "sine";
  oscillator.frequency.value = frequency;
  gain.gain.setValueAtTime(0.0001, startTime);
  gain.gain.exponentialRampToValueAtTime(0.2, startTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
  oscillator.connect(gain);
  gain.connect(ctx.destination);
  oscillator.start(startTime);
  oscillator.stop(startTime + duration);
}

export function playNotificationSound() {
  const ctx = getAudioContext();
  if (!ctx) return;
  const resume = ctx.state === "suspended" ? ctx.resume() : Promise.resolve();
  resume
    .then(() => {
      const now = ctx.currentTime;
      playTone(ctx, 880, now, 0.12);
      playTone(ctx, 1175, now + 0.1, 0.15);
    })
    .catch(() => {});
}
